var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecentlyViewed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#314e55",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      fillRule: "evenodd"
    },
    transform: "translate(6 5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.4581272 22.9511894c1.2745829 4.6650588 5.0646115 8.0488106 9.5418728 8.0488106s8.2672899-3.3837518 9.5418728-8.0488106c1.3982-.2550677 2.4581272-1.4793489 2.4581272-2.9511894 0-1.3861595-.940115-2.5527435-2.2175263-2.8969332-.9588383-5.2007827-4.9743833-9.1030668-9.7824737-9.1030668s-8.8236354 3.9022841-9.7824737 9.1030668c-1.2774113.3441897-2.2175263 1.5107737-2.2175263 2.8969332 0 1.4718405 1.0599272 2.6961217 2.4581272 2.9511894z",
    fill: "#e9e7d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36 42c0-6.0751322-4.9248678-11-11-11s-11 4.9248678-11 11z",
    fill: "#e9e7d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 3,
    fill: "#ea86a5",
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 4,
    fill: "#5ecb66",
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 34,
    fill: "#ea86a5",
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 49,
    fill: "#5ecb66",
    r: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.25388316 33.050991 7.06442074-4.1075913"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.65915294 5.6533153 5.41637756 3.72895858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m44.4196438 5.85123695-6.6662305 6.18615975"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m43.8060607 46.1701453-8.1335628-16.103625"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyViewed);
export default __webpack_public_path__ + "static/media/recentlyViewed.2fdbe1f3930ba8c6e73caf7b842d2383.svg";
export { ForwardRef as ReactComponent };